<template>
  <div class="award_content">
    <div class="award_ranking">
      <div class="department">
        <div class="timeRadio">
          <el-radio-group
            v-model="workDateType"
            size="mini"
            @input="getdepartInfo"
          >
            <el-radio-button label="1">本月</el-radio-button>
            <el-radio-button label="2">本季度</el-radio-button>
            <el-radio-button label="3">本年</el-radio-button>
          </el-radio-group>
        </div>
        <div id="manageId"></div>
      </div>
    </div>
    <div class="award_table">
      <div class="table_title">完成率明细</div>
      <div class="table_form">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="公司">
            <el-select
              v-model="formInline.company"
              placeholder="公司"
              size="mini"
              style="display: flex;flex-direction: column;"
            >
              <el-option label="天人" value="天人"></el-option>
              <el-option label="国真" value="国真"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <div class="block">
              <!-- <el-date-picker
                size="mini"
                v-model="value2"
                type="month"
                placeholder="选择月"
              >
              </el-date-picker> -->
              <el-select
                v-model="formInline.showDate"
                placeholder="请选择"
                size="mini"
                style="display: flex;flex-direction: column;"
                @change="accomplishDetailHeader"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in dateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit"
              >查询</el-button
            >
            <!-- <el-button size="mini" @click="reset">重置</el-button> -->
            <el-button size="mini" @click="exportWork">导出</el-button>
            <el-button size="mini" @click="importFiles">
              导入
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table_menu">
        <el-table :data="tableData" border style="width: 100%" height="300">
          <el-table-column
            align="center"
            prop="deptName"
            label="部门"
            width="180"
          >
          </el-table-column>
          <!-- <el-table-column align="center" label="1月1周">
            <el-table-column align="center" prop="oneWeekNum" label="数量"></el-table-column>
            <el-table-column align="center" prop="oneWeekRatio" label="完成率"></el-table-column>
          </el-table-column> -->
          <el-table-column
            v-for="item in columnList"
            :key="item.prop"
            align="center"
            :label="item.showDate"
          >
            <el-table-column
              align="center"
              :prop="item.num"
              label="数量"
            ></el-table-column>
            <el-table-column
              align="center"
              :prop="item.ratio"
              label="完成率"
            ></el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import {
  getaccomplishRate,
  getShowDate,
  getAccomplishDetail,
  importExcel,
  accomplishDetailHeader,
  exportWork
} from "@/api/morningMeet";
export default {
  name: "Statistical",
  data() {
    return {
      xAxisList: [],
      chartsData: [],
      onexAxisList: [],
      onechartsData: [],
      myChart: "",
      oneselfChart: "",
      dateVal: "",
      dateValone: "",
      formInline: {
        company: "天人",
        showDate: null
      },
      tableData: [],

      awardDateVal: [],
      ruleForm: {},
      day: moment().format("YYYY-MM-DD"),
      startTime: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endTime: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      open: false,
      page: 1,
      workDateType: "1",
      dateList: [],
      columnList: [
        {
          label: "1月1周",
          prop: "oneWeekNum",
          prop1: "oneWeekRatio"
        },
        {
          label: "1月2周",
          prop: "twoWeekNum",
          prop1: "twoWeekRatio"
        },
        {
          label: "1月3周",
          prop: "threeWeekNum",
          prop1: "threeWeekRatio"
        },
        {
          label: "1月4周",
          prop: "fourWeekNum",
          prop1: "fourWeekRatio"
        },
        {
          label: "1月5周",
          prop: "fiveWeekNum",
          prop1: "fiveWeekRatio"
        }
      ]
    };
  },
  mounted() {
    this.getDateList();
    setTimeout(() => {
      this.getdepartInfo();
      // this.initEcharts();
      // this.initOneself();
    }, 1000);
  },
  methods: {
    handleClose() {
      this.open = false;
    },
    add() {},
    onSubmit() {
      this.getAccomplishDetail();
    },
    initEcharts() {
      var chartDom = document.getElementById("manageId");
      var chartsOption = {
        title: {
          text: "完成率统计"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: function(params) {
            var result = params[0].name + "<br>";
            params.forEach(function(item) {
             item.value =  item.value.toFixed(2)
              if (item.value !== null && item.value !== undefined) {
                result += item.seriesName + " : " + item.value + "%<br>";
              } else {
                result += item.seriesName + " : -<br>";
              }
            });
            return result;
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisList,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              fontSize: 8
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "（%）",
            minInterval: 1
          }
        ],
        series: [
          {
            name: "完成率",
            type: "bar",
            barWidth: "60%",
            data: this.chartsData,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
          }
        ]
      };
      this.myChart = echarts.init(chartDom);
      chartsOption && this.myChart.setOption(chartsOption);
    },
    async getdepartInfo() {
      const params = {
        dateType: this.workDateType
      };
      const { code, data } = await getaccomplishRate(params);
      if (code != 0) return;
      this.xAxisList = data.map(el => {
        return el.deptName;
      });
      this.chartsData = data.map(el => {
        return el.ratio * 100;
      });
      this.initEcharts();
      // this.myChart.setOption({
      //   xAxis: [{ data: this.xAxisList }],
      //   series: [{ data: this.chartsData }],
      // });
    },
    async accomplishDetailHeader() {
      const {code ,data} = await accomplishDetailHeader({showDate:this.formInline.showDate})
      if(code != 0) return;
      this.columnList = data
      this.getAccomplishDetail();
    },
    async getAccomplishDetail() {
      const { code, data } = await getAccomplishDetail(this.formInline);
      if (code != 0) return;
      this.tableData = data
    },
    async getDateList() {
      const { code, data } = await getShowDate();
      if (code != 0) return;
      this.dateList = data.map(item => {
        return {
          label: item,
          value: item
        };
      });
      this.formInline.showDate = this.dateList[0].value;
      this.getAccomplishDetail();
      this.accomplishDetailHeader()
    },
    importFiles() {
      const inputUpload = document.createElement('input');
      inputUpload.type = 'file'
      inputUpload.ref = 'filImport'
      inputUpload.addEventListener('change', (e) => {
        const file = inputUpload.files[0]
        const formData = new FormData()
        formData.append('file',file)
        importExcel(formData).then(res => {
          if(res.code !==0 ) return
          this.$message.success("导入成功");
          this.getDateList()
        })
      })
      inputUpload.click()
    },
    exportWork() {
      exportWork({ ...this.formInline}).then(res => {
        const exportFileName = decodeURIComponent(res.headers['content-disposition'].match(/filename="([^"]+)"/)[1])||'文件';
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("id", "pdfID");
        link.setAttribute("download", `${exportFileName}.xls`);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.award_content {
  width: 100%;
  height: 380px;
  .award_ranking {
    display: flex;
    width: 100%;
    height: 380px;

    .department {
      width: 100%;
      position: relative;
      .timeRadio {
        position: absolute;
        right: 16%;
      }
      #manageId {
        width: 90%;
        height: 100%;
        margin-top: 16px;
      }
    }
  }
  .award_table {
    width: 100%;
    height: 380px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .table_title {
      width: 100%;
      font-weight: 600;
      font-size: 18px;
      color: #333;
    }
    .table_form {
      width: 70%;
    }
    .table_menu {
      width: 90%;
      height: 380px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MorningMeeting/CriticalWork.vue